import { z } from 'zod';

/**
 * Region kind. Implies a 5+1-level hierarchy (parent inferred from `type`, no stored ref):
 *
 * - `country`        — top level. Google: `country`.
 * - `state`          — Saudi province / منطقة (ADM1, 13 in SA). Google: `administrative_area_level_1`.
 * - `governorate`    — Saudi محافظة (ADM2, 147 in SA, the routing layer). Google: `administrative_area_level_2`.
 * - `city`           — populated place / مدينة. Google: `locality`.
 * - `neighborhood`   — Google: `neighborhood` / `sublocality`.
 * - `hub`            — Saudi-specific logistics anchor (port, industrial city, free zone, border crossing); child of `city`.
 *
 * Parent of any region is resolved at read time by `$geoIntersects` of `region.center`
 * against the parent type's `boundaries`. See `RegionService.getParentRegion`.
 */
export const regionTypeSchema = z.enum([
  'country',
  'state',
  'governorate',
  'city',
  'neighborhood',
  'hub',
]);
export type RegionType = z.infer<typeof regionTypeSchema>;
